import { buildTestAttributeSelector, testContextOperator } from './logzTestGenerator';
export var IconSelectors;
(function (IconSelectors) {
    let IconAttributesName;
    (function (IconAttributesName) {
        IconAttributesName["Context"] = "context";
    })(IconAttributesName || (IconAttributesName = {}));
    IconSelectors.selectAllIcons = buildTestAttributeSelector(IconAttributesName.Context, 'icon', testContextOperator.Starts);
    IconSelectors.selectIconByContext = (context) => buildTestAttributeSelector(IconAttributesName.Context, `icon.${context}`);
})(IconSelectors || (IconSelectors = {}));
//# sourceMappingURL=icon.selectors.js.map